const baseStyle = {
  _stack: {
    margin: 'auto',
    position: 'absolute',
    space: 2,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'box-none',
  },
  _overlay: {},
  _container: {
    px: '4',
    py: '2',
    rounded: 'sm',
    shadow: 2,
    flexDirection: 'row',
    alignItems: 'center',
    w: '370px',
  },
  _description: {
    fontWeight: 400,
    marginRight: 'auto',
    fontSize: 'md',
    lineHeight: 'md',
  },
  _icon: {
    mr: '2',
    size: '5',
  },
  _dismiss: {
    ml: '2',
    size: '4',
  },
  _undo: {
    ml: '2',
    fontSize: 'md',
    lineHeight: 'md',
  },
};

const variantDark = {
  _container: {
    bgColor: 'gray.600',
  },
  _description: {
    color: 'white',
  },
  _icon: {
    color: 'white',
  },
  _dismiss: {
    color: 'white',
  },
  _undo: {
    _text: {
      color: 'white',
    },
  },
};

const variantLight = {
  _container: {
    bgColor: 'white',
  },
  _description: {
    color: 'darkText',
  },
  _icon: {
    color: 'darkText',
  },
  _dismiss: {
    color: 'darkText',
  },
  _undo: {
    _text: {
      color: 'darkText',
    },
  },
};

const variants = {
  dark: variantDark,
  light: variantLight,
};

export default {
  baseStyle,
  variants,
  defaultProps: {
    variant: 'dark',
  },
};
